import React from 'react';
import './PayPage.scss';
import { contacts } from "../configs/contacts";

export function PayPage() {
    return (
        <div className='pay-page'>
            <div className='pay-page__block div1'>
                <h3>Оплата наличными в офисе</h3>
                <p>Оплатить туристические услуги наличными можно в офисе нашей компании. Это самый надежный и быстрый
                    способ оплаты туров. Без комиссий, наценок банков и посредников.
                    Оплата производится в белорусских рублях по курсу туроператора. Подтверждением оплаты является
                    договор и
                    кассовый чек.</p>
                <h3>Сервис E-POS</h3>
                Сервис E-POS позволяет оплачивать товары и услуги банковской картой через ЕРИП путем получения счета в
                виде специального QR-кода.
                <ol>
                    <li> Выбираем туристическое путешествие, подписываем договор. Мы выставляем счет на оплату,
                        генерирует для счета QR-код. Сгенерированный QR-код предоставляем туристу/плательщику.
                    </li>
                    <li> Для оплаты по QR-коду необходимо отсканировать его изображение. Далее происходит переход на
                        специально созданную страницу оплаты.
                    </li>
                    <li> На защищенной странице выставленный счет мгновенно оплачивается банковской картой или мобильным
                        банкингом через ЕРИП.
                    </li>
                    <li> После успешной оплаты приходит уведомление в Viber
                    </li>
                </ol>
            </div>
            <div className='pay-page__block div2'>
                <h3>Безналичная оплата</h3>
                <p>Безналичная оплата — это способ расчётов между юридическими или физическими лицами посредством
                    банковских платежей.
                    Вы можете самостоятельно заполнить квитанции, используя наши реквизиты, либо связаться с нами для
                    получения счёта.</p>
                <h3>Наши реквизиты:</h3>
                <p>Название организации: ООО «ВояжГлобал»
                    <br></br>
                    УНП: 193765582 ОКПО: 505106925000<br></br>
                    Юридический и почтовый адрес: 220005, г. Минск, ул. В. Хоружей 3, офис 305а
                    <br></br>
                    ЗАО "МТБанк" БИК MTBKBY22<br></br>
                    Р/с BY97MTBK30120001093300125977
                </p>
            </div>
            <div className='pay-page__block div3'>
                <a
                    className='pay-page__block-heading'
                    href='https://webpay.by/'
                    target='_blanc'
                ><h3 className='pay-page__block-heading'>webpay </h3></a>
                <br/>
                После заключения индивидуального договора наш менеджер выставит ссылку на оплату в мессенджер или
                электронную почту.<br/>
                Мы принимаем платежи по следующим банковским картам: Visa, Visa Electron, MasterCard, Maestro, Белкарт,
                МИР.
                <img
                    className='pay-page__block-img'
                    src={require(`../assets/pay-logo.png`)}
                    alt='logo'
                />
                <br/>
                <p>Безопасный сервер <a
                    href='https://webpay.by/'
                    target='_blanc'
                >WEBPAY</a> устанавливает шифрованное соединение по защищенному протоколу TLS и конфиденциально
                    принимает от
                    клиента данные его платёжной карты (номер карты, имя держателя, дату окончания действия, и
                    контрольный номер банковской карточке CVC/CVC2).
                </p>
                <br></br>
                <p>После совершения оплаты с использованием банковской карты необходимо сохранять полученные карт-чеки
                    (подтверждения об оплате) для сверки с выпиской из карт-счёта (с целью подтверждения совершённых
                    операций в случае возникновения спорных ситуаций).</p>
                <br></br>
                <p>В случае, если Вы не получили заказ (не оказана услуга), Вам необходимо обратиться (в службу
                    технической
                    поддержки) по телефону <a
                        href={`tel:${contacts?.[0].value}`}
                        target='_blank'
                        className='pay-page__block-contact'
                    >{contacts?.[0].value}</a> или e-mail <a
                        href={`mailto:${contacts?.[2].value}`}
                        target='_blank'
                        className='pay-page__block-contact'
                    >{contacts?.[2].value}</a>. Менеджеры Вас проконсультируют.
                </p>
                <br></br>
                <p>При оплате банковской платежной картой возврат денежных средств осуществляется на карточку, с которой
                    была произведена оплата".</p>
                <a
                    className='pay-page__block-link'
                    target='_blanc'
                    href='/contract.pdf'
                >Публичный договор
                </a>
            </div>
        </div>
    )
}
